export function pluralize(word: string): string {
  // Handle special cases
  if (word.endsWith('y')) {
    return word.slice(0, -1) + 'ies'
  }
  // Add more special cases as needed

  // Default case
  return word + 's'
}
